/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getDefaultBusinessId.internal

import features.getDefaultBusinessId.models.DefaultBusiness
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.getDefaultBusinessId.internal.GetDefaultBusinessIdUseCase.Params

internal class GetDefaultBusinessIdUseCase : AsyncUseCase<DefaultBusiness, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val getDefaultBusinessIdService: GetDefaultBusinessIdService = GetDefaultBusinessIdServiceImpl()

    override suspend fun run(params: Params): Result<DefaultBusiness> {
        return getDefaultBusinessIdService.getDefaultBusinessId(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
